import React from 'react';
import { components } from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GLOBAL } from '../../utils/Constants';

export const customStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    borderColor: isFocused ? '#5f5f58' : '#d1d1d1',
    '&:hover': {
      borderColor: 'none',
    },
    boxShadow: 'none',
    fontFamily: 'Poppins Regular',
    fontSize: '12px',
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 3,
  }),
  noOptionsMessage: (styles) => ({
    ...styles,
    fontSize: '12px',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => {
    let background;
    let color = '#a4a4a3';
    let textAlign = GLOBAL.LEFT;
    let fontStyle = 'initial';
    if (isFocused && !isSelected) {
      background = '#f7f7f7';
    } else if (isSelected) {
      background = '#bee0fa';
      color = '#175b90';
    } else {
      background = 'none';
    }
    if (isDisabled) {
      textAlign = 'center';
    }
    return {
      ...styles,
      backgroundColor: background,
      textAlign,
      fontStyle,
      color,
      fontSize: '12px',
    };
  },
  indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
  multiValue: (base) => ({ ...base, margin: 0 }),
};

export const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon="search" />
      </components.DropdownIndicator>
    )
  );
};

export const LoadingIndicator = () => {
  return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: 'spinner-third' }} spin />;
};
